import React, { FC } from 'react';

import styles from './centered-panel.module.sass';

export const CenteredPanel : FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({className, ...props}) => {
  return  <div {...props} className={`${styles.centeredPanel} ${className ?? ""}`}>
      {props.children}
  </div>
}
